import { Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';
import { rolesStoreProviders } from '@telespot/authentication/ui';
import {
  affiliatedUserStoreProviders,
  userMembershipsStoreProviders,
  workspaceStoreProviders,
} from '../../../providers/store.providers';
import { UserEditorFacade } from './user-editor.facade';

/**
 * Providers for UserEditorFacade and its dependencies.
 * Composes store providers with the facade.
 */
export function userEditorFacadeProviders(): Provider[] {
  return [
    ...affiliatedUserStoreProviders(),
    ...userMembershipsStoreProviders(),
    ...rolesStoreProviders(),
    ...workspaceStoreProviders(PaginatedStateLoadingMode.CONTINUOUS),
    UserEditorFacade,
  ];
}
